import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { FilterButtonModel } from '@shared/models/filters/filter-button-model';
import { makeFilter } from '@shared/utils/filter-utils';
import { TuiBadgeNotification, TuiSegmented } from '@taiga-ui/kit';
import { combineLatest, first, map, Observable, of, switchMap } from 'rxjs';
import { FilterType } from 'src/app/shared/models/filters/filter-type.enum';
import { FilterBarService } from '../filter-bar.service';

@Component({
  selector: 'pxc-filter-buttons',
  templateUrl: './filter-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TuiBadgeNotification, TuiSegmented, TranslocoDirective],
})
export class FilterButtonsComponent {
  private readonly filterBarService = inject(FilterBarService);

  template$ = this.filterBarService.templates$.pipe(
    map((templates) => templates.find((template) => template.type === FilterType.BUTTONS)),
  );

  selectedIndex$ = this.template$.pipe(switchMap((template) => this.filterBarService.getSelectedIndex$(template)));

  buttons$ = this.template$.pipe(
    switchMap((template) => (template ? (template.getValue('') as Observable<FilterButtonModel[]>) : of(null))),
  );

  updateFilters(button: FilterButtonModel, index: number): void {
    combineLatest([this.template$, this.selectedIndex$])
      .pipe(first())
      .subscribe(([template, selectedIndex]) => {
        if (index === selectedIndex) {
          return;
        }

        this.filterBarService.updateTemplate({
          ...template,
          filters: [...(button.value ? [makeFilter(button, template)] : [])],
        });
      });
  }
}
